
import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Group, LdapTreeNode } from '@/models/group'
import { Assignment, AssignmentPerType } from '@/models/assignments'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import ProgressLinear from '../Atomic/ProgressLinear.vue'
import AutocompleteMultipleWTooltip from '../Atomic/AutocompleteMultipleWTooltip.vue'

import AssignmentService from '@/services/AssignmentService'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import GroupService from '@/services/GroupService'
import { INotificationService } from '@/services/NotificationService'
@Component({
  components: {
    AutocompleteMultipleWTooltip,
    GreenButton,
    ProgressLinear,
    RedButton,
  },
})
export default class GroupForm extends Vue {
  @Prop(Function) public readonly fetchAssignements!: (groupId: number) => AssignmentPerType
  @Prop(Function) public readonly onClose!: () => void
  @Prop() private readonly groups: Group[]
  private pending: boolean = false
  private group: Group = new Group(0, '', '', false, '', false, '', '', '')
  private assignments: AssignmentPerType | [] = []
  private ldapTree: LdapTreeNode[] = []
  private $notificationService!: INotificationService

  private groupFormDialog: boolean = false
  private stepNumber: number = 1
  private errorHandlerService: ErrorHandlerService
  private isInitializingRessources: boolean = false
  private isEditingDn: boolean = false
  private sources: string[] = ['EXTRA', 'REFEDU']
  private existingName: string = ''
  private existingEmail: string = ''

  public async show(group: Group | undefined) {
    this.errorHandlerService = new ErrorHandlerService()
    this.isInitializingRessources = true
    this.groupFormDialog = true
    if (group !== undefined ) {
      this.group = group
      this.existingName = this.group.nom
      this.existingEmail = this.group.courriel
      const groupAssignements = await this.fetchAssignements(group.groupe_ad_id)
      group.assignments = groupAssignements
    }
    await this.fetchAssignementsPerType()
    await this.fetchLdapTree()
    this.isInitializingRessources = false
  }

private async fetchLdapTree() {
  try {
    this.pending = true
    this.ldapTree = await GroupService.fetchLdapTree()
  } catch (error: any) {
    this.errorHandlerService.handle(this, error.response.data.code, true)
  } finally {
    this.pending = false
  }
}

private async fetchAssignementsPerType() {
  try {
    this.pending = true
    this.assignments = await AssignmentService.fetchAssignmentsPerType()
  } catch (error: any) {
    this.errorHandlerService.handle(this, error.response.data.code, true)
  } finally {
    this.pending = false
  }
}

  private previous() {
    this.stepNumber -= 1
  }

  private async next() {
    const validated = await this.$validator.validateAll()
    if (validated) {
      this.stepNumber += 1
    }
  }

  private async validate() {
  try {
    this.pending = true
    if (this.group.groupe_ad_id === 0) {
      await GroupService.create(this.group)
      this.$notificationService.success(this.$t('GROUPS.GroupCreated').toString())
    } else {
      await GroupService.update(this.group, this.group.groupe_ad_id)
      this.$notificationService.success(this.$t('GROUPS.GroupEdited').toString())
    }
    await this.closeDialog()
  } catch (error: any) {
    this.errorHandlerService.handle(this, error.response.data.code, true)
  } finally {
    this.pending = false
  }
  }

  private async closeDialog() {
    this.groupFormDialog = false
    this.stepNumber = 1
    this.group = new Group(0, '', '', false, '', false, '', '', '')
    this.assignments = []
    this.existingName = ''
    this.existingEmail = ''
    this.onClose()
  }

  private onSelectTreeNode(nodes: LdapTreeNode[]) {
    this.group.groupe_dn = nodes[0].dn
    this.isEditingDn = false
  }
  private mounted() {

  }

  private get isNameValid() {
    switch (this.group.nom) {
      case '':
        return 'false'
      case this.existingName:
        return this.group.nom
      default:
        if (this.group.nom !== this.existingName && this.groups.find((grp) => grp.nom === this.group.nom) === undefined) {
          return this.group.nom
        }
        return 'false'
    }
  }

  private get isEmailValid() {
    switch (this.group.courriel) {
      case '':
        return 'false'
      case this.existingEmail:
        return this.group.courriel
      default:
        if (this.group.courriel !== this.existingEmail && this.groups.find((grp) => grp.courriel === this.group.courriel) === undefined) {
          return this.group.courriel
        }
        return 'false'
    }
  }
}
